import { render, staticRenderFns } from "./archive-list.vue?vue&type=template&id=518fdcce&scoped=true"
import script from "./archive-list.vue?vue&type=script&lang=js"
export * from "./archive-list.vue?vue&type=script&lang=js"
import style0 from "./archive-list.vue?vue&type=style&index=0&id=518fdcce&prod&lang=less"
import style1 from "./archive-list.vue?vue&type=style&index=1&id=518fdcce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518fdcce",
  null
  
)

export default component.exports